/* tslint:disable */
/* eslint-disable */
export enum ServiceordreStatusEnum {
  None = 'None',
  Broadcasted = 'Broadcasted',
  CompletedWithAccounting = 'CompletedWithAccounting',
  CompletedWithRejection = 'CompletedWithRejection',
  ApprovedForInvoicing = 'ApprovedForInvoicing',
  Cancelled = 'Cancelled',
  Invoiced = 'Invoiced',
  InvoicingFailed = 'InvoicingFailed',
  Created = 'Created',
  ValidationFailed = 'ValidationFailed',
  ReadyForBroadcast = 'ReadyForBroadcast',
  BroadcastFailed = 'BroadcastFailed',
  Parked = 'Parked'
}
